import { ThesisSubmissionIterationStatusOutcome } from '@rdm/db'

export const ThesisSubmissionIterationStatusOutcomeEnum: { [K in ThesisSubmissionIterationStatusOutcome]: K } = {
  ADVANCED: 'ADVANCED',
  REJECTED: 'REJECTED',
  WITHDRAWN_BY_GRADUATE: 'WITHDRAWN_BY_GRADUATE',
  REVISE_AND_RESUBMIT: 'REVISE_AND_RESUBMIT',
  FAILED: 'FAILED',
  REPEAT_ORAL: 'REPEAT_ORAL',
  DOWNGRADE_TO_MPHIL: 'DOWNGRADE_TO_MPHIL',
} as const

export const initialDeanOutcomes: { code: ThesisSubmissionIterationStatusOutcome; name: string }[] = [
  { code: 'ADVANCED', name: 'Pass' },
  { code: 'REJECTED', name: 'Pass with corrections' },
  { code: 'REVISE_AND_RESUBMIT', name: 'Requested revise and resubmit' },
  { code: 'REPEAT_ORAL', name: 'Repeat oral requested' },
  { code: 'FAILED', name: 'Failed' },
  { code: 'DOWNGRADE_TO_MPHIL', name: 'Downgraded to MPhil' },
]

export const iterationOutcomes: { code: ThesisSubmissionIterationStatusOutcome; name: string }[] = [
  { code: 'ADVANCED', name: 'Advanced' },
  { code: 'REJECTED', name: 'Rejected' },
  { code: 'WITHDRAWN_BY_GRADUATE', name: 'Withdrawn by graduate' },
  { code: 'REVISE_AND_RESUBMIT', name: 'Requested revise and resubmit' },
  { code: 'REPEAT_ORAL', name: 'Repeat oral requested' },
  { code: 'FAILED', name: 'Failed' },
  { code: 'DOWNGRADE_TO_MPHIL', name: 'Downgraded to MPhil' },
]
